import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;
if(value > 37.5) {
    return { 
      title: 'มีไข้ต่ำ',
      color: 'yellow',
      caption: 'มีไข้ต่ำ',
      suggest: 'กรุณาไปพบแพทย์'
    };
  } 
  else if(value > 40) {
    return { 
      title: 'มีไข้สูง',
      color: 'red',
      caption: 'มีไข้สูง',
      suggest: 'กรุณาไปพบแพทย์'
    };
  } 
  
  else {
    return { 
      title: 'อุณหภูมิปกติ',
      color: 'green',
      caption: 'อุณหภูมิปกติ',
      suggest: ''
    };
  }

}